import * as React from 'react';
import { Container } from '@estee/elc-grid';
import { configConsumer } from '@estee/elc-service';
import { observer } from 'mobx-react';
import { CategoryHeader } from './CategoryHeader';
import { ProductGridHeaders } from './ProductGridHeaders';

export interface IProductGridHeader {
    config?: IProductGridHeaderConfig;
    categoryTag: string;
    isWrappedByContainer: boolean;
}

interface IProductGridHeaderConfig {
    productGridHeader?: string;
    productGridSubheader?: string;
    enableCategoryHeader?: boolean;
    showDynamicCategoryHeader?: boolean;
    categoryHeaderH1?: boolean;
}

export const ProductGridHeader = configConsumer([
    'productGridHeader',
    'productGridSubheader',
    'enableCategoryHeader',
    'showDynamicCategoryHeader',
    'categoryHeaderH1'
])(
    observer(function ProductGridHeader(props: IProductGridHeader) {
        const {
            productGridHeader,
            productGridSubheader,
            enableCategoryHeader,
            showDynamicCategoryHeader,
            categoryHeaderH1
        } = props.config as IProductGridHeaderConfig;

        const { categoryTag, isWrappedByContainer } = props;

        if (!enableCategoryHeader) {
            return null;
        }

        const generateContent = (): JSX.Element | null => {
            // If grid header or subheader were provided, use them to fill the header.
            if (productGridHeader || productGridSubheader) {
                return (
                    <ProductGridHeaders
                        productGridHeader={productGridHeader}
                        productGridSubheader={productGridSubheader}
                        categoryHeaderH1={categoryHeaderH1}
                    />
                );
            } else if (showDynamicCategoryHeader && categoryTag) {
                // Fall back to default category header if enabled
                return <CategoryHeader categoryTag={categoryTag} />;
            }

            return null;
        };

        const content = generateContent();

        if (!content) {
            return null;
        }

        return isWrappedByContainer ? <Container>{content}</Container> : content;
    })
);
